module.exports = __webpack_public_path__ + "img/product_71.2c8b4e0.webp";